import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import "./Navbar.css"
import Logo from "../../images/Logo.png"


function Navbar() {

  const links = [
    {
      Text: "Home",
      Link: "/"
    },
    {
      Text: "Admissions",
      Link: "/admissions/"
    },
    {
      Text: "Institutions",
      Link: "/institutions/"
    },
    {
      Text: "Amenities",
      Link: "/amenities/"
    },
    {
      Text: "News",
      Link: "/news/"
    },
    {
      Text: "Gallery",
      Link: "/gallery/"
    },
     {
      Text: "Udaan 2k24",
      Link: "https://drive.google.com/drive/folders/1-N4TJUlcpZxHaiG3w4gvsUkzZAfZ6cj4?usp=sharing"
    },
    {
      Text: "About Us",
      Link: "/about/"
    }
  ]

  const [menuOpen, toggleMenuOpen] = useState(false)


  // window.onbeforeunload = ()=> {
  //     window.scrollTo(0, 0);
  //     toggleMenuOpen(false)
  //   }

  useEffect(() => {
    const handleResize = window.addEventListener("resize", () => {
      if (menuOpen) {
        toggleMenuOpen(false)
      }
    })

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [menuOpen])

  useEffect(() => {
    const header = document.getElementById("navlinks")
    const sticky = header.offsetTop
    const scrollCallBack = window.addEventListener("scroll", () => {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky")
      } else {
        header.classList.remove("sticky")
      }
    })
    return () => {
      window.removeEventListener("scroll", scrollCallBack)
    }
  }, [])


  return (
    <div>

            {/*<Announcements {...announcementsData} />*/}
            <Wrapper menuOpen={menuOpen} >
                <NavBar id='navlinks'>
                    <MenuIconContainer>
                        <Head>
                           <img src={Logo} alt='logo' ></img>
                        </Head>
                        <MenuIcon id="toggler" menuOpen={menuOpen} onClick = {() => toggleMenuOpen(!menuOpen)}>
                            <div />
                            <div />
                            <div />
                        </MenuIcon>
                    </MenuIconContainer >
                        <Links>
                        <Head>
                        <img src={Logo} alt='logo' ></img>
                        </Head>
                            {links.map((link, index)=>{
                                return(
                                    <Link to={link.Link} key={index}>{link.Text}</Link>
                                )
                            })}
                        </Links>
                        <LinksMobile menuOpen={menuOpen} id="section" >
                            {links.map((link, i)=>{
                                return(
                                    <Link to={link.Link} key={i}>{link.Text}</Link>
                                )
                            })}
                        </LinksMobile>

        </NavBar>
      </Wrapper>
    </div>
  )
}

export default Navbar

const Head = styled.div`
    position: absolute;
    left: 15px;
    top: 2px;
    color: var(--textRed);
    img{
        height: 58px;
    }
`
const Wrapper = styled.div`
    min-height: 62px;
    transition: all 0.3s linear;
    @media only screen and (max-width : 1100px) {
      min-height: 70px;
    }
`

const NavBar = styled.div`
    width: 100%;
    z-index: 5;
    //height: auto;
`

const MenuIconContainer = styled.div`
    position: relative;
    display: none;
    justify-content: flex-end;
    align-items: center;
    -webkit-tap-highlight-color: transparent;
    background-color: var(--primaryWhite);
    padding: 0.9rem;
    z-index: 10;
    @media only screen and (max-width: 1100px){
        display: flex;
    }
`
const MenuIcon = styled.button`
    cursor: pointer;
    background: transparent;
    border:none;
    outline:none;
     /* without this outline property the hamburger gets a border when clicked, despite border's value being none  */
    display:flex;
    flex-direction: column;
    justify-content: space-around;
    align-content: center;
    height: 2.1rem;
    z-index:11;
    -webkit-tap-highlight-color: transparent;


    div {
        width: 2rem;
        height: 0.24rem;
        background: #C71F16;
        border-radius: 10px;
        transform-origin: 1px;
        transition: opacity 50ms, transform 200ms;

        :first-child {
            transform: ${({ menuOpen }) => (menuOpen ? "rotate(45deg)" : "rotate(0)")};
        }
        :nth-child(2) {
            opacity: ${({ menuOpen }) => (menuOpen ? "0" : "1")};
        }

        :nth-child(3){
            transform: ${({ menuOpen }) => (menuOpen ? "rotate(-45deg)" : "rotate(0)")};
        }
    }
   
`
const Links = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    background-color: var(--primaryWhite); 
    align-items: center;
    list-style: none;
    width: 100%;
    font-family: var(--headerFont);

    a{
        color: #000000;
        display: flex;
        padding: 1rem var(--spacer-3) 1rem var(--spacer-3);
        align-content: center;
        font-size: var(--font-3);
        cursor: pointer;
        text-decoration: none;
        box-shadow: none;

        :hover{
        background-color: var(--primaryRedHover);
        color: #ffffff;
        }
        :active{
            background-color: var(--primaryRedHover);
            color: #ffffff; 
        }

    }
    @media only screen and (max-width: 1100px){
        display: none;
    }

`
const LinksMobile = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    background-color: var(--primaryWhite);
    list-style: none;
    width: 100%;
    transition: all 0.3s linear;
    //max-height: 0;
    max-height: ${({ menuOpen }) => (menuOpen ? "500px" : "0")};
    height: auto;
    overflow: hidden;
    z-index: 10;
    transition: all 0.2s linear;
    a{
        color: #000000;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 1rem 1.5rem 1rem 1.5rem;
        align-items: center;
        justify-items: center;
        cursor: pointer;
        text-decoration: none;
        box-shadow: none;
        font-family: var(--headerFont);
        
        :hover{
        background-color: var(--primaryRedHover);
        color: #ffffff;
        }
    }   

`
//
// // Announcement component data
// const announcementsData = {
//   announcements: ["This is a announcement. Nice to meet you.", "This is another mock announcement. Nice to meet you again."]
// }
